import { Injectable } from "@angular/core";
import { StorageKey } from "../models/Enum";

@Injectable({
    providedIn: "root",
})
export class BrowserStorageService {
    getItem<T>(key: StorageKey | string, canParse = true): T | string {
        const item = sessionStorage.getItem(key) ?? localStorage.getItem(key);
        if (canParse && item) {
            return JSON.parse(item) as T;
        } else {
            return item;
        }
    }

    setItem(key: StorageKey | string, value: any, isLocal = false) {
      var storage = isLocal ? localStorage : sessionStorage;
      if (typeof value === "string") {
          storage.setItem(key, value);
      } else {
          storage.setItem(key, JSON.stringify(value));
      }
    }

    clear() {
        Object.values(StorageKey).map((key) =>{
            sessionStorage.removeItem(key);
            localStorage.removeItem(key);
        });
    }
}
